// If any permission is changed or added or removed in the backend then the respective change should be done in the below as well
export const pageConstant = {
    SL_QUOTE_DASHBOARD: 'SL_QUOTE_DASHBOARD',
    SL_DESK_SUMMARY_EOD: 'SL_DESK_SUMMARY_EOD',
    MTD_YTD: 'MTD_YTD',
    TRADE_BOOKING: 'TRADE_BOOKING',
    CONTRACT_ACTIVITY: 'CONTRACT_ACTIVITY',
    AUTO_BORROW: 'AUTO_BORROW',
    AUTO_LOAN: 'AUTO_LOAN',
    DTC_ACTIVITY: 'DTC_ACTIVITY',
    LOAN_RETURNS: 'LOAN_RETURNS',
    RECALLS: 'RECALLS',
    SECMASTER: 'SECMASTER',
    REPORTS: 'REPORTS',
    CPTY: 'CPTY',
    USER_MANAGEMENT: 'USER_MANAGEMENT',
    SERVICE_MANAGER: 'SERVICE_MANAGER',
    LOCATE_DASHBOARD: 'LOCATE_DASHBOARD',
    SUPPLY_MANAGEMENT: 'SUPPLY_MANAGEMENT',
    RATES_DASHBOARD: 'RATES_DASHBOARD',
    USER_PROFILE: 'USER_PROFILE',
    SUPER_ADMIN: 'SUPER_ADMIN',
    LOCATE_CLIENT: 'LOCATE_CLIENT',
    CPTY_EXPOSURE: 'CPTY_EXPOSURE',
    PL_SUMMARY: 'PL_SUMMARY',
    POSITION_BROWSER: 'POSITION_BROWSER',
    SL_TRADE_DTC: 'SL_TRADE_DTC',
    FAQ: 'FAQ',
    HELP_CENTER: 'HELP_CENTER',
    SL_DASHBOARD: 'SL_DASHBOARD',
    TRADE_ACTIVITY: 'TRADE_ACTIVITY',
     RISK_BY_CPTY: 'RISK_BY_CPTY',
      FOCUS_REPORTS_DASHBOARD: 'FOCUS_REPORTS_DASHBOARD',
     
  RISK_BY_SECURITY: 'RISK_BY_SECURITY',
  RISK_LIQUIDITY_DASHBOARD: 'RISK_LIQUIDITY_DASHBOARD',
  }
  
  export const Permissions = {
    Read: 'RO',
    Write: 'WO',
    ReadWrite: 'RW',
    Admin: 'ADMIN'
  }
  
export const tradeRoles = [`${pageConstant.TRADE_BOOKING}_${Permissions?.Admin}`, `${pageConstant.TRADE_BOOKING}_${Permissions?.ReadWrite}`, `${pageConstant.TRADE_BOOKING}_${Permissions?.Read}`]
export const contractBrowserRoles = [`${pageConstant.CONTRACT_ACTIVITY}_${Permissions?.Admin}`, `${pageConstant.CONTRACT_ACTIVITY}_${Permissions?.ReadWrite}`, `${pageConstant.CONTRACT_ACTIVITY}_${Permissions?.Read}`]
export const dtcRoles = [`${pageConstant.DTC_ACTIVITY}_${Permissions?.Admin}`, `${pageConstant.DTC_ACTIVITY}_${Permissions?.ReadWrite}`, `${pageConstant.DTC_ACTIVITY}_${Permissions?.Read}`]
export const secmasterRoles = [`${pageConstant.SECMASTER}_${Permissions?.Admin}`, `${pageConstant.SECMASTER}_${Permissions?.ReadWrite}`, `${pageConstant.SECMASTER}_${Permissions?.Read}`]
export const cptyRoles = [`${pageConstant.CPTY}_${Permissions?.Admin}`, `${pageConstant.CPTY}_${Permissions?.ReadWrite}`, `${pageConstant.CPTY}_${Permissions?.Read}`]
export const loanReturnsRoles = [`${pageConstant.LOAN_RETURNS}_${Permissions?.Admin}`, `${pageConstant.LOAN_RETURNS}_${Permissions?.ReadWrite}`, `${pageConstant.LOAN_RETURNS}_${Permissions?.Read}`]
export const recallRoles = [`${pageConstant.RECALLS}_${Permissions?.Admin}`, `${pageConstant.LOAN_RETURNS}_${Permissions?.ReadWrite}`, `${pageConstant.LOAN_RETURNS}_${Permissions?.Read}`]
export const userManagementRoles = [`${pageConstant.USER_MANAGEMENT}_${Permissions?.Admin}`, `${pageConstant.USER_MANAGEMENT}_${Permissions?.ReadWrite}`, `${pageConstant.USER_MANAGEMENT}_${Permissions?.Read}`]
export const ratesDashboardRoles = [`${pageConstant.RATES_DASHBOARD}_${Permissions?.Admin}`, `${pageConstant.RATES_DASHBOARD}_${Permissions?.ReadWrite}`, `${pageConstant.RATES_DASHBOARD}_${Permissions?.Read}`]
export const supplyManagementRole = [`${pageConstant.SUPPLY_MANAGEMENT}_${Permissions?.Admin}`, `${pageConstant.SUPPLY_MANAGEMENT}_${Permissions?.ReadWrite}`, `${pageConstant.SUPPLY_MANAGEMENT}_${Permissions?.Read}`]
export const slQuoteRoles = [`${pageConstant.SL_QUOTE_DASHBOARD}_${Permissions?.Admin}`, `${pageConstant.SL_QUOTE_DASHBOARD}_${Permissions?.ReadWrite}`, `${pageConstant.SL_QUOTE_DASHBOARD}_${Permissions?.Read}`]
export const locateDashboardRole = [`${pageConstant.LOCATE_DASHBOARD}_${Permissions?.Admin}`, `${pageConstant.LOCATE_DASHBOARD}_${Permissions?.ReadWrite}`, `${pageConstant.LOCATE_DASHBOARD}_${Permissions?.Read}`]
export const slDeskEODSummaryRoles = [`${pageConstant.SL_DESK_SUMMARY_EOD}_${Permissions?.Admin}`, `${pageConstant.SL_DESK_SUMMARY_EOD}_${Permissions?.ReadWrite}`, `${pageConstant.SL_DESK_SUMMARY_EOD}_${Permissions?.Read}`]
export const locateClientRoles = [`${pageConstant.LOCATE_CLIENT}_${Permissions?.Admin}`, `${pageConstant.LOCATE_CLIENT}_${Permissions?.ReadWrite}`, `${pageConstant.LOCATE_CLIENT}_${Permissions?.Read}`]
export const focusReportsRoles = [
  `${pageConstant.FOCUS_REPORTS_DASHBOARD}_${Permissions.Admin}`,
  `${pageConstant.FOCUS_REPORTS_DASHBOARD}_${Permissions.ReadWrite}`,
  `${pageConstant.FOCUS_REPORTS_DASHBOARD}_${Permissions.Read}`,
]

export const riskCPTYRoles = [
  `${pageConstant.FOCUS_REPORTS_DASHBOARD}_${Permissions.Admin}`,
  `${pageConstant.FOCUS_REPORTS_DASHBOARD}_${Permissions.ReadWrite}`,
  `${pageConstant.FOCUS_REPORTS_DASHBOARD}_${Permissions.Read}`,
]

export const riskLiqDashboardRoles = [
  `${pageConstant.RISK_LIQUIDITY_DASHBOARD}_${Permissions.Admin}`,
  `${pageConstant.RISK_LIQUIDITY_DASHBOARD}_${Permissions.ReadWrite}`,
  `${pageConstant.RISK_LIQUIDITY_DASHBOARD}_${Permissions.Read}`,
]


export const navMenuItems = [
    {
      label: "Dashboards",
      submenu: [
        {
          label: "SL Quote Dashboard",
          link: "/sl-quote",
          param:'/MSFT',
          permissions: [...slQuoteRoles],
        },
        {
          label: "EOD Summary Dashboard",
          link: "/eod-summary",
          permissions: [...slDeskEODSummaryRoles],
        },
      ],
       icon: 'tabler:smart-home',
      permissions: [...slQuoteRoles, ...slDeskEODSummaryRoles],
      link:'/dashboards'
    },
    {
      label: "Trading",
      submenu: [
        {
          label: "Trade Entry",
          link: "/contract",
          permissions: [...tradeRoles],
        },
        {
          label: "Contract Browser",
          link: "/contract-browser",
          permissions: [...contractBrowserRoles],
        },
      ],
      permissions: [...tradeRoles, ...contractBrowserRoles],
      icon: 'icon-park-outline:stock-market',
      link:'/trading'
    },
    {
      label: "Operations",
      submenu: [
        {
          label: "DTC Dashboard",
          link: "/dtc-dashboard",
          permissions: [...dtcRoles],
        },
        {
          label: "Callbacks",
          link: "/callbacks",
          permissions: [...loanReturnsRoles],
        },
        { label: "Recalls", link: "/recalls", permissions: [...recallRoles] },
      ],
      permissions: [...dtcRoles, ...loanReturnsRoles, ...recallRoles],
      icon: 'ep:operation',
      link:'/operations'
    },
    {
      label: "Reference Data",
      submenu: [
        {
          label: "Sec Master",
          link: "/sec-master",
          permissions: [...secmasterRoles],
        },
        {
          label: "CounterParty Data",
          link: "/counter-party",
          permissions: [...cptyRoles],
        },
      ],
      permissions: [...secmasterRoles, ...cptyRoles],
      icon: 'basil:document-outline',
      link:'/reference-data'
    },
    {
      label: "Locates",
      submenu: [
        {
          label: "Locates Dashboard",
          link: "/locates-dashboard",
          permissions: [...locateDashboardRole],
        },
        {
          label: "Rates Dashboard",
          link: "/rates-dashboard",
          permissions: [...ratesDashboardRoles],
        },
        {
          label: "Supply Management",
          link: "/supply-management",
          permissions: [...supplyManagementRole],
        },
        {
          label: "Locates PNL",
          link: "/locates-pnl",
          permissions: [...locateDashboardRole],
        },
        {
          label: "Locates Client",
          link: "/locates-client",
          permissions: [...locateClientRoles],
        },
      ],
      permissions: [
        ...ratesDashboardRoles,
        ...locateDashboardRole,
        ...supplyManagementRole,
        ...locateClientRoles
      ],
      icon: 'carbon:search-locate',
      link:'/locates'
    },

     {
      label: "Risk",
      submenu: [
         {
          label: "Liquidity Risk Dashboard",
          link: "/liquidity-risk-dashboard",
         permissions: [...riskLiqDashboardRoles],
        },
        {
          label: "CPTY Master",
          link: "/risk-by-cpty",
         permissions: [...riskCPTYRoles],
        }

      ],
     permissions: [...riskCPTYRoles, ...riskLiqDashboardRoles],
      icon: 'carbon:search-locate',
      link:'/risk'
    },

  ];